import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material"
import CenteredText from "components/CenteredText"
import MenuCard from "components/MenuCard";
import Page from "components/Page"
import { tokenAtom } from "lib/globalState";
import BgAreaX from 'assets/images/areax_card.png'
import BgIc from 'assets/images/ic_card.png'
import BgPepper from 'assets/images/play_pepper_card.png'
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil"

const SceltaIniziale = () => {

    const theme = useTheme();
    const history = useHistory();
    const token = useRecoilValue(tokenAtom);


    return (<Page syncNavCommand="SCEGLI_PROSEGUO">
        <Stack sx={{
            display: 'flex',
            flex: 1,
        }}>
            <CenteredText>
                <Typography variant="h5" color={theme.palette.primary.main}>Scegli da cosa iniziare: </Typography>
            </CenteredText>
            <MenuCard bg={BgAreaX} to="/scopri_areax">
                <div>
                    <Typography variant="h6" color={theme.palette.white.main} sx={{ fontWeight: 'bold' }}>Scopri Area X,</Typography>
                    <Typography variant="h6" color={theme.palette.white.main}> il mondo della protezione</Typography>
                </div>
            </MenuCard>
            <MenuCard bg={BgIc} to="/scopri_ic">
                <div>
                    <Typography variant="h6" color={theme.palette.white.main} sx={{ fontWeight: 'bold' }}>Scopri Innovation Experience,</Typography>
                    <Typography variant="h6" color={theme.palette.white.main}> il mondo dell'innovazione</Typography>
                </div>
            </MenuCard>
            <MenuCard bg={BgPepper} to={token ? "/gioca_pepper" : ""} style={{ opacity: token ? 1 : 0.5 }}>
                <div>
                    <Typography variant="h6" color={theme.palette.white.main} sx={{ fontWeight: 'bold' }}>{token ? 'Gioca con Pepper' : 'Per giocare con Pepper'},</Typography>
                    <Typography variant="h6" color={theme.palette.white.main}>{token ? 'il robot umanoide' : 'scansiona il QR Code'}</Typography>
                </div>
            </MenuCard>


            <CenteredText>
                <Button variant="outlined" color="primary" onClick={() => history.push('/fine')}>Esci</Button>
            </CenteredText>
        </Stack>
    </Page>)
}
export default SceltaIniziale